import { render } from "./Exclusion.vue?vue&type=template&id=0e615950"
import script from "./Exclusion.vue?vue&type=script&lang=js"
export * from "./Exclusion.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__